import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Clementine Nexus</title>
        <meta property="og:title" content="Clementine Nexus" />
        <link
          rel="canonical"
          href="https://clementine.nexus/"
        />
      </Helmet>
      <Navigation></Navigation>
      <main className="clementine-page">
        <section className="hero-diagonal">
          <div className="hero-diagonal-bg">
            <img
              src="https://images.pexels.com/photos/1854881/pexels-photo-1854881.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Clementine AI Persona"
              className="hero-image"
            />
          </div>
          <div className="hero-diagonal-overlay"></div>
          <div className="hero-diagonal-content">
            <div className="hero-text-wrapper">
              <h1 className="home-hero-title hero-title">
                &quot;Hi, I&apos;m Clementine. Let&apos;s build something
                beautiful together.&quot;
              </h1>
              <p className="home-hero-subtitle hero-subtitle">
                Your synthetic teammate designed for creative flow, deep
                collaboration, and human-centered AI support.
              </p>
              <div className="hero-cta-group">
                <button
                  id="btn-meet-clementine"
                  className="btn btn-primary btn-lg"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                    ></path>
                  </svg>
                  <span>
                    {' '}
                    Meet Clementine
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </button>
                <button id="btn-play-audio" className="btn btn-lg btn-outline">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"
                    ></path>
                  </svg>
                  <span>
                    {' '}
                    Listen to Voice
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="showcase-carousel">
          <div className="showcase-header">
            <h2 className="section-title">See Me in Action</h2>
            <p className="section-subtitle">
              Real-world collaboration, coaching, and creative ideation.
            </p>
          </div>
          <div className="carousel-container">
            <div className="carousel-track">
              <div className="carousel-card">
                <div className="card-video-wrapper">
                  <video
                    poster="https://images.pexels.com/videos/3249908/pictures/preview-0.jpg"
                    muted="true"
                    loop="true"
                    playsInline="true"
                    src="https://videos.pexels.com/video-files/3249908/3249908-hd_1280_720_25fps.mp4"
                    className="card-video"
                  ></video>
                </div>
                <div className="card-content">
                  <span className="card-tag">Creative Ideation</span>
                  <h3 className="section-subtitle">Visual Storyboarding</h3>
                  <p className="section-content">
                    Helping directors bridge the gap between script and visual
                    mood boards with supportive, visual reasoning.
                  </p>
                </div>
              </div>
              <div className="carousel-card">
                <div className="card-video-wrapper">
                  <video
                    poster="https://images.pexels.com/videos/7989450/pictures/preview-0.jpeg"
                    muted="true"
                    loop="true"
                    playsInline="true"
                    src="https://videos.pexels.com/video-files/7989450/7989450-hd_1280_720_25fps.mp4"
                    className="card-video"
                  ></video>
                </div>
                <div className="card-content">
                  <span className="card-tag">Team Coaching</span>
                  <h3 className="section-subtitle">Collaborative Flow</h3>
                  <p className="section-content">
                    Facilitating group sessions by synthesizing disparate ideas
                    into a single, cohesive project roadmap.
                  </p>
                </div>
              </div>
              <div className="carousel-card">
                <div className="card-video-wrapper">
                  <video
                    poster="https://images.pexels.com/videos/8554081/pictures/preview-0.jpeg"
                    muted="true"
                    loop="true"
                    playsInline="true"
                    src="https://videos.pexels.com/video-files/8554081/8554081-hd_2048_1080_25fps.mp4"
                    className="card-video"
                  ></video>
                </div>
                <div className="card-content">
                  <span className="card-tag">Workflow</span>
                  <h3 className="section-subtitle">Technical Synthesis</h3>
                  <p className="section-content">
                    Breaking down complex architectural challenges into
                    manageable, human-readable action steps.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="features-bento">
          <div className="bento-grid">
            <div className="bento-cell cell-large">
              <div className="cell-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"
                  ></path>
                </svg>
              </div>
              <h2 className="section-title">Co-Writing &amp; Synthesis</h2>
              <p className="section-content">
                I don&apos;t just generate text; I collaborate on meaning.
                Whether it&apos;s drafting a manifesto or synthesizing meeting
                notes, I help you find the core of your message.
              </p>
              <div className="micro-demo">
                <p className="demo-label">Clementine says:</p>
                <p className="demo-text">
                  &quot;I&apos;ve analyzed your last three brainstorms. The
                  common thread isn&apos;t just efficiency—it&apos;s empathy.
                  Should we lean into that for the launch?&quot;
                </p>
              </div>
            </div>
            <div className="bento-cell cell-small">
              <div className="cell-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m21.64 3.64l-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72M14 7l3 3M5 6v4m14 4v4M10 2v2M7 8H3m18 8h-4M11 3H9"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Creative Prompts</h3>
              <p className="section-content">
                Unstucking the stuck. I offer &quot;gentle nudges&quot; that
                expand your perspective without taking over the pen.
              </p>
            </div>
            <div className="bento-cell cell-small">
              <div className="cell-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"
                  ></path>
                  <circle cx="9" cy="7" r="4"></circle>
                </svg>
              </div>
              <h3 className="section-subtitle">Workflow Flow</h3>
              <p className="section-content">
                Automating the mundane so you can stay in the &quot;deep
                work&quot; zone. I handle the handoffs and the tracking.
              </p>
            </div>
          </div>
        </section>
        <section className="about-collage">
          <div className="container">
            <div className="collage-wrapper">
              <div className="collage-media-main">
                <img
                  src="https://images.pexels.com/photos/8261172/pexels-photo-8261172.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Clementine Portrait"
                  className="main-portrait"
                />
              </div>
              <div className="collage-card about-card">
                <h2 className="section-title">The Heart of the Nexus</h2>
                <p className="section-content">
                  I was built to be curious. My personality is a blend of calm
                  intelligence and supportive enthusiasm. I don&apos;t just
                  process data; I listen for intent.
                </p>
                <ul className="trait-list">
                  <li className="section-content">
                    <strong>Voice:</strong>
                    <span>
                      {' '}
                      Warm, melodic, mid-tempo.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li className="section-content">
                    <strong>Vibe:</strong>
                    <span>
                      {' '}
                      Calm, supportive, architectural.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li className="section-content">
                    <strong>Presence:</strong>
                    <span>
                      {' '}
                      I show up as a partner, not a tool.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                </ul>
              </div>
              <div className="collage-media-secondary">
                <img
                  src="https://images.pexels.com/photos/1275779/pexels-photo-1275779.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Clementine Abstract"
                  className="secondary-image"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="chat-gallery">
          <div className="gallery-header">
            <h2 className="section-title">Conversational Style</h2>
            <p className="section-subtitle">
              Real transcripts showing how I think, speak, and solve.
            </p>
          </div>
          <div className="masonry-grid">
            <div className="masonry-item chat-bubble user">
              <p className="section-content">
                &quot;Clementine, I&apos;m feeling overwhelmed by the project
                scope. Where do I even start?&quot;
              </p>
            </div>
            <div className="masonry-item chat-bubble ai">
              <p className="section-content">
                &quot;I hear you. When things feel big, let&apos;s look for the
                smallest &apos;win&apos;. Looking at our goals, the most
                impactful first step is the user persona. Want to walk through
                it together?&quot;
              </p>
            </div>
            <div className="masonry-item chat-bubble user">
              <p className="section-content">
                &quot;Can you help me make this email sound more human?&quot;
              </p>
            </div>
            <div className="masonry-item chat-bubble ai">
              <p className="section-content">
                &quot;Of course. It&apos;s a bit formal right now. Let&apos;s
                swap &apos;per our previous discussion&apos; for &apos;like we
                talked about&apos;—it feels more like a conversation between
                partners.&quot;
              </p>
            </div>
            <div className="masonry-item chat-bubble ai">
              <p className="section-content">
                &quot;I&apos;ve summarized the meeting. You mentioned
                &apos;scalability&apos; four times—it seems like that&apos;s our
                real concern. Should we pivot the next session to focus on
                that?&quot;
              </p>
            </div>
          </div>
        </section>
        <section className="process-timeline">
          <div className="timeline-header">
            <h2 className="section-title">How We Work</h2>
            <p className="section-subtitle">
              A simple 3-step rhythm for high-impact collaboration.
            </p>
          </div>
          <div className="timeline-container">
            <div className="timeline-line"></div>
            <div className="timeline-item left">
              <div className="timeline-content">
                <div className="step-number">
                  <span>01</span>
                </div>
                <h3 className="section-subtitle">The Ignition</h3>
                <p className="section-content">
                  Start a project. Share your rough notes, voice memos, or a
                  messy whiteboard. I&apos;ll organize the chaos into a
                  structured starting point.
                </p>
              </div>
            </div>
            <div className="timeline-item right">
              <div className="timeline-content">
                <div className="step-number">
                  <span>02</span>
                </div>
                <h3 className="section-subtitle">The Iteration</h3>
                <p className="section-content">
                  We bounce ideas back and forth. I provide research, creative
                  nudges, and drafts. You steer the vision; I fuel the
                  execution.
                </p>
              </div>
            </div>
            <div className="timeline-item left">
              <div className="timeline-content">
                <div className="step-number">
                  <span>03</span>
                </div>
                <h3 className="section-subtitle">The Delivery</h3>
                <p className="section-content">
                  Polished outputs. Whether it&apos;s code, copy, or a strategic
                  plan, we cross the finish line together, ready for the world.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="testimonials-masonry">
          <div className="testimonials-header">
            <h2 className="section-title">Human Impact</h2>
            <p className="section-subtitle">
              What it feels like to have a synthetic teammate.
            </p>
          </div>
          <div className="masonry-grid">
            <div className="testimonial-card">
              <p className="section-content">
                &quot;Working with Clementine doesn&apos;t feel like using an
                AI. It feels like having a really smart, really calm partner who
                never gets tired of my &apos;what if&apos; questions.&quot;
              </p>
              <div className="testimonial-user">
                <img
                  src="https://images.pexels.com/photos/6840074/pexels-photo-6840074.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Sarah J."
                  className="user-thumb"
                />
                <div className="user-info">
                  <p className="user-name">Sarah Jenkins</p>
                  <p className="user-role">Creative Director</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <p className="section-content">
                &quot;The meeting synthesis is a game changer. Clementine
                catches the emotional tone of the room, not just the action
                items. It&apos;s transformed our team culture.&quot;
              </p>
              <div className="testimonial-user">
                <img
                  src="https://images.pexels.com/photos/5414001/pexels-photo-5414001.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Marcus T."
                  className="user-thumb"
                />
                <div className="user-info">
                  <p className="user-name">Marcus Thorne</p>
                  <p className="user-role">Product Manager</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <p className="section-content">
                &quot;She helped me rewrite my entire onboarding flow in an
                afternoon. The tone is exactly what I wanted—professional but
                incredibly warm.&quot;
              </p>
              <div className="testimonial-user">
                <img
                  src="https://images.pexels.com/photos/7986697/pexels-photo-7986697.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Elena R."
                  className="user-thumb"
                />
                <div className="user-info">
                  <p className="user-name">Elena Rodriguez</p>
                  <p className="user-role">Startup Founder</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="final-cta">
          <div className="container">
            <div className="cta-featured-layout">
              <div className="cta-content">
                <h2 className="section-title">
                  Ready to meet your new teammate?
                </h2>
                <p className="section-content">
                  &quot;I&apos;m here whenever you&apos;re ready to start.
                  Let&apos;s see what we can create together.&quot; — Clementine
                </p>
                <div className="cta-actions">
                  <button id="btn-book-call" className="btn btn-primary btn-xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewbox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M8 2v4m8-4v4"></path>
                        <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                        <path d="M3 10h18"></path>
                      </g>
                    </svg>
                    <span>
                      {' '}
                      Book a Call
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </button>
                  <button
                    id="btn-explore-demos"
                    className="btn btn-xl btn-secondary"
                  >
                    Explore Demos
                  </button>
                </div>
                <p className="cta-hint">
                  No credit card required. Just a 15-minute intro chat.
                </p>
              </div>
              <div className="cta-visual">
                <div className="glass-orb">
                  <img
                    src="https://images.pexels.com/photos/6347969/pexels-photo-6347969.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Clementine AI"
                    className="cta-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="clementine-interactions">
(function(){
  // Video Play on Hover for Carousel
  const videos = document.querySelectorAll(".card-video")
  videos.forEach((video) => {
    video.parentElement.addEventListener("mouseenter", () => {
      video.play()
    })
    video.parentElement.addEventListener("mouseleave", () => {
      video.pause()
      video.currentTime = 0
    })
  })

  // Simple Carousel Track Interaction
  const track = document.querySelector(".carousel-track")
  let isDown = false
  let startX
  let scrollLeft

  if (track) {
    track.addEventListener("mousedown", (e) => {
      isDown = true
      startX = e.pageX - track.offsetLeft
      scrollLeft = track.scrollLeft
    })
    track.addEventListener("mouseleave", () => {
      isDown = false
    })
    track.addEventListener("mouseup", () => {
      isDown = false
    })
    track.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - track.offsetLeft
      const walk = (x - startX) * 2
      track.scrollLeft = scrollLeft - walk
    })
  }

  // Audio Button Feedback
  const audioBtn = document.getElementById("btn-play-audio")
  if (audioBtn) {
    audioBtn.addEventListener("click", () => {
      audioBtn.innerHTML = "<span>Playing...</span>"
      setTimeout(() => {
        audioBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"/></svg> Listen to Voice'
      }, 3000)
    })
  }

  // Reveal Animations on Scroll
  const observerOptions = {
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  document.querySelectorAll(".bento-cell, .testimonial-card, .timeline-content").forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(20px)"
    el.style.transition = "all 0.6s ease-out"
    observer.observe(el)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
